// "use client";
// import React, { useState } from "react";
// import styles from "./TestActions.module.css";

// const TestActions = ({ setSelectedTestType }) => {
//   const [activeType, setActiveType] = useState("t");

//   // Function to handle category selection
//   const handleCategoryClick = (type) => {
//     setActiveType(type);
//     setSelectedTestType(type);
//   };

//   return (
//     <section className={styles.testActions}>
//       {/* Navigation Tabs */}
//       <nav className={styles.actionTabs}>
//         <button className={styles.actionTab}>View or create resume</button>
//         <button className={styles.actionTab}>View or create video</button>
//         <button className={styles.actionTab}>View or create audio</button>
//         <button className={styles.actionTab}>Interview Result</button>
//       </nav>

//       {/* Search Bar */}
//       <div className={styles.searchBar}>
//         <input
//           type="text"
//           placeholder="Search"
//           className={styles.searchInput}
//         />
//         <img
//           src="https://cdn.builder.io/api/v1/image/assets/TEMP/23e4a9cdca8becb8233a7164538b0b0d9eabf3b3658d3047ba370ee01957cd64?apiKey=e90a33775c2844879a20708b8df7376f"
//           alt="Search"
//           className={styles.searchIcon}
//         />
//       </div>
//         {/* Test Type Buttons */}
//        <div className={styles.testTypes}>
//          <button className={`${styles.testTypeBtn} ${styles.active}`}>Schedule Test</button>
//          <button className={styles.testTypeBtn}>Mock Test</button>
//          <button className={styles.testTypeBtn}>Coding Practice</button>
//        </div>

//       {/* Test Type Buttons */}
//       <div className={styles.testTypes}>
//         <button
//           className={`${styles.testTypeBtn} ${
//             activeType === "t" ? styles.active : ""
//           }`}
//           onClick={() => handleCategoryClick("t")}
//         >
//           Screening Test
//         </button>
//         <button
//           className={`${styles.testTypeBtn} ${
//             activeType === "c" ? styles.active : ""
//           }`}
//           onClick={() => handleCategoryClick("c")}
//         >
//           Coding Test
//         </button>
//       </div>
//     </section>
//   );
// };

// export default TestActions;



"use client";
import React, { useState } from "react";
import { ScheduleTest } from "./Popup/ScheduleTest";
import { Inline } from '@/components/ui/layout';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
} from "@/components/ui/dialog";
import { cn } from '@/lib/utils';

const TestActions = ({ setSelectedTestType }) => {
  const [activeType, setActiveType] = useState("t");
  const [codingPopup, setCodingPopup] = useState(false);
  const [mockPopup, setMockPopup] = useState(false);
  const [quizPopup, setQuizPopup] = useState(false);

  const handleCategoryClick = (type) => {
    setActiveType(type);
    setSelectedTestType(type);
  };

  const testTypes = [
    { id: "t", label: "Mock Interviews" },
    { id: "c", label: "Quizzes" },
    { id: "p", label: "Coding Practice" },
  ];

  return (
    <>
      <Button
        variant="default"
        className="mb-4"
        onClick={() => {
          if (activeType === "p") {
            setCodingPopup(true);
          } else if (activeType === "t") {
            setMockPopup(true);
          } else if (activeType === "c") {
            setQuizPopup(true);
          }
        }}
      >
        {activeType === "t" ? "+ Take Mock AI Test" : (activeType === "c" ? "+ Take a Quiz" : "+ Practice Coding")}
      </Button>

      <Inline spacing="md" align="center" className="w-full justify-around border-b-2 border-muted px-2.5">
        {testTypes.map((type) => (
          <Button
            key={type.id}
            variant="ghost"
            className={cn(
              "text-base font-medium text-foreground border-b-4 border-transparent rounded-none",
              activeType === type.id && "border-primary text-primary"
            )}
            onClick={() => handleCategoryClick(type.id)}
          >
            {type.label}
          </Button>
        ))}
      </Inline>

      <Dialog open={mockPopup} onOpenChange={setMockPopup}>
        <DialogContent>
          <ScheduleTest onClose={() => setMockPopup(false)} testType="interview" />
        </DialogContent>
      </Dialog>

      <Dialog open={quizPopup} onOpenChange={setQuizPopup}>
        <DialogContent>
          <ScheduleTest onClose={() => setQuizPopup(false)} testType="quiz" />
        </DialogContent>
      </Dialog>

      <Dialog open={codingPopup} onOpenChange={setCodingPopup}>
        <DialogContent>
          <ScheduleTest onClose={() => setCodingPopup(false)} testType="coding" />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default TestActions;